'use strict';

var novicell = novicell || {};

novicell.imageSpot = novicell.imageSpot || new function () {

  this.init = function () {
    let objectFitNotExists = Modernizr.objectfit;
    let image_spots = document.querySelectorAll('.js-image-spot');
    if (image_spots.length) {
      for (let i = 0; i < image_spots.length; i++) {
        if (!objectFitNotExists) {
          let container = image_spots[i].querySelector('.image-spot__image');
          let imageUrl = container.querySelector('img').getAttribute('data-src');
          if (imageUrl) {
            container.style.backgroundImage = 'url('+imageUrl+')';
            container.classList.add('compat-object-fit');
          }
        }
        image_spots[i].addEventListener('mouseenter', function () {
          if (!('ontouchstart' in window)) {
            if (this.classList.contains('image-spot--can-flip')) {
              this.querySelector('.image-spot__face--back').classList.add('image-spot__face--active');
            } else if (this.classList.contains('image-spot--link-hover')) {
              this.querySelector('.image-spot__image').classList.add('image-spot__image--zoom');
            }
          }
        });
        image_spots[i].addEventListener('mouseleave', function () {
          if (!('ontouchstart' in window)) {
            if (this.classList.contains('image-spot--can-flip')) {
              this.querySelector('.image-spot__face--back').classList.remove('image-spot__face--active');
            } else if (this.classList.contains('image-spot--link-hover')) {
              this.querySelector('.image-spot__image').classList.remove('image-spot__image--zoom');
            }
          }
        });
        image_spots[i].addEventListener('touchstart', function (event) {
          if (this.classList.contains('image-spot--can-flip')) {
            let back = this.querySelector('.image-spot__face--back');
            back.classList.toggle('image-spot__face--active');
            if (!back.classList.contains('js-image-spot-touchstart-activated')) {
              event.preventDefault();
              event.stopImmediatePropagation();
              back.classList.add('js-image-spot-touchstart-activated');
            } else {
              back.classList.remove('js-image-spot-touchstart-activated');
            }
          }
        });
      }
    }
  };
}();
